var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.content.split(',')),function(item,itemIndex){return _c('span',{key:_vm.name + '-' + itemIndex},[_c('span',{staticClass:"badge badge-pill mx-1",style:({ backgroundColor: _vm.getColor(item, _vm.name) })},[_vm._v(_vm._s(item))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71923207","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/TableCellBadge.vue
// module id = 595
// module chunks = 38